@if (!(filesLoading$ | async)) {
  <p class="margin-left margin-right">Per Ohio security policy all links to files displayed here will be invalid after two minutes. Please click <button class="refresh-link" (click)="refreshLinks()">here</button> to regenerate valid links.</p>
  @if (organizationHasNoFiles) {
    Organization currently has no files.
  }
  @for (tag of tags; track tag) {
    <div>
      @if (showAccordionSection(tag.value)) {
        <div class="accordion">
          <div [id]="tag.value" class="accordion-header bold" (click)="accordion(tag.value)">
            <div class="accordion-cell">
              @if (isSectionExpanded(tag.value) === false) {
                <svg-icon icon="icon-caret-right" class="black"></svg-icon>
              }
              @if (isSectionExpanded(tag.value) === true) {
                <svg-icon icon="icon-caret-down" class="black"></svg-icon>
              }
            </div>
            <div class="accordion-cell">{{tag.displayName}}</div>
          </div>
          <div class="accordion-section" [ngStyle]="{'display': (isSectionExpanded(tag.value)) ? 'inherit' : 'none'}">
            <table>
              <caption>{{caption}}</caption>
              <thead>
                <tr>
                  <th>
                    Document Type
                  </th>
                  <th>
                    Document Name
                  </th>
                  <th>
                    <div class="sortable-cell">
                      Date
                    </div>
                    <div class="sortable-cell">
                      <button (click)="sort(tag.value, 'date', 'asc')"><svg-icon icon="icon-caret-up" class="small medium-gray"></svg-icon></button><br />
                      <button (click)="sort(tag.value, 'date', 'desc')"><svg-icon icon="icon-caret-down" class="small medium-gray"></svg-icon></button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (file of getSectionDocuments(tag.value); track file) {
                  <tr>
                    <td>
                      <ul>
                        @for (tag of file.tags; track tag) {
                          <li>
                            {{tag.tag}} : {{tag.value}}
                          </li>
                        }
                      </ul>
                    </td>
                    <td>
                      <a href="{{file.url}}" rel="noopener noreferrer" target="_blank">{{file.name}}</a>
                    </td>
                    <td>
                      {{dateFormatter(file.auditDate)}}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  }
} @else {
  <div class="loader-container">
    <static-loader></static-loader>
  </div>
}
